import { egresadosApiCall } from "../../../../axios/apiClient";

const controller = `expLaboral`;

export default {
    getExpLaboralMe : async () => {
        let  response = { success: true };
        const method = `me`;
        try {
            const apiResponse = await egresadosApiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    createExpLaboralMe: async (data) => {
        let response = { success: true };
        const method = `me`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    editExpLaboralMe: async (data) => {
        let response = { success: true };
        const method = `me`;
        try {
            const apiResponse = await egresadosApiCall.put(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    deleteExpLaboralMe: async (id) => {
        let response = { success: true };
        const method = `me/${id}`;
        try {
            const apiResponse = await egresadosApiCall.delete(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    }

}
